export const requireBookingId = (bookingId, navigate) => {
  if (bookingId) return true;
  if (typeof navigate === 'function') {
    navigate('/stays', { replace: true });
  }
  return false;
};

export const requireGuestComplete = (draft, navigate) => {
  const guest = draft?.guestDetails;
  const ok = !!(guest?.fullName && guest?.email && guest?.phone);
  if (ok) return true;
  if (typeof navigate === 'function') {
    navigate('/booking/guest', { replace: true });
  }
  return false;
};

export const requireConfirmed = (draft, navigate) => {
  const ok = draft?.status === 'PENDING_PAYMENT';
  if (ok) return true;
  if (typeof navigate === 'function') {
    navigate('/booking/review', { replace: true });
  }
  return false;
};
